import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-file-list-3-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">
                Hipobuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Your comprehensive guide to Hipobuy Spreadsheet product research. Find better products, compare categories, and shop smarter with organized spreadsheet resources.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-4">
              Quick Links
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <a href="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#hipobuy-spreadsheet" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Hipobuy Spreadsheet
                </a>
              </li>
              <li>
                <a href="#categories" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Categories
                </a>
              </li>
              <li>
                <a href="#comparison" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Comparison
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-4">
              Resources
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/hipobuy-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Hipobuy Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Kakobuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  CSSBuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/superbuy-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Superbuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/oopbuy-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Oopbuy Spreadsheet Guide
                </Link>
              </li>
              <li>
                <a href="#safety" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  Safety Tips
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base text-background-50 mb-4">
              Disclaimer
            </h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              This website is an independent informational resource and is not officially affiliated with Hipobuy, Kakobuy, CSSBuy, Superbuy, or Oopbuy. All trademarks belong to their respective owners. We provide research guides and educational content to help users make informed decisions.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} Hipobuy Spreadsheet Guide. All rights reserved.
          </p>
          <p className="text-xs text-foreground-600">
            Independent resource — not affiliated with any spreadsheet platform.
          </p>
        </div>
      </div>
    </footer>
  );
}